'use client';

import Image from 'next/image';
import Link from 'next/link';
import { IFooter } from '@/types/components/footer';
import { ButtonNetwork } from '../social-networks/ButtonNetwork';
import {
  faFacebook,
  faInstagram,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

export const Footer: React.FC<IFooter> = ({ logo }) => {
  return (
    <>
      <section
        id="footer"
        className="relative h-auto p-2 xl:mx-[6.5vw] lg:mx-[6.5vw] md:mx-[5vw] sm:mx-[4vw] xs:mx-[0vw]"
      >
        <div className="absolute top-0 right-0 mt-2 mr-4 flex space-x-6">
          <ButtonNetwork icon={faTiktok} link="https://www.tiktok.com/@theclub.off" />
          <ButtonNetwork icon={faYoutube} link="https://www.youtube.com/@need_for_touring" />
          <ButtonNetwork icon={faFacebook} link="https://www.facebook.com/people/The-club-need-for-touring/61565940851900/" />
          <ButtonNetwork icon={faInstagram} link="https://www.instagram.com/theclub_nftouring/" />
        </div>
        <div className="flex lg:flex-row xs:flex-col lg:items-center md:items-left border-b-2 p-2 pb-6 mb-6 sm:mt-4 xs:mt-6">
          <Link
            href="https://www.carfooly.com"
            title="Redirection vers le site de Carfooly"
          >
            <Image
              src={logo}
              alt="Logo The Club"
              title="Logo The Club"
              width={200}
              height={200}
              priority
              className="h-auto xl:w-[18vw] lg:w-[20vw] md:w-[28vw] sm:w-68 xs:w-64 mt-2 mb-4 mr-4"
            />
          </Link>
          <div className="flex flex-wrap justify-left items-center gap-2 sm:gap-4 w-full lg:ml-8 md:ml-0">
          <Link
              href="/legal-notices"
              title="Redirection vers les mentions légales"
              className="font-primaryLight lg:text-lg xs:text-base mr-4 hover:text-red-600 whitespace-nowrap"
            >
              Mentions légales
            </Link>
            <Link
              href="https://www.iubenda.com/privacy-policy/65092721"
              className="mr-4 font-primaryLight hover:text-red-600 whitespace-nowrap"
            >
              Politique de confidentialité
            </Link>
            <Link
              href="https://www.iubenda.com/privacy-policy/65092721/cookie-policy"
              className="mr-4 font-primaryLight hover:text-red-600 whitespace-nowrap"
            >
              Gestion des cookies
            </Link>
            <Link
              href="https://www.iubenda.com/conditions-generales/65092721"
              className="font-primaryLight hover:text-red-600 whitespace-nowrap"
            >
              CGU
            </Link>
          </div>
        </div>
        <div className="font-primaryLight w-full text-left ml-2 mt-4 sm:mt-2">
        <p className="mb-2">2024 CARFOOLY. Tous droits réservés.</p>
          <p className="sm:max-w-[90%] mb-2 text-sm text-gray-400">
            Carfooly SAS Center d&apos;affaire - Ecoparc Départemental 55 Rue de
            la garriguette, 34130 Saint-Aunès, France
          </p>
          <p className="sm:max-w-[95%] text-sm text-gray-400">
            Capital social : €725,000.00 - SIRET n°: 90161486700025 - 901 614
            867 R.C.S Montpellier
          </p>
        </div>
      </section>
    </>
  );
};